import Logo from "../../assets/logo.jpg";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Form, Input, Button, Typography, Space, message, Grid, Avatar } from "antd";
import {
  UserOutlined,
  LockOutlined,
  LoginOutlined,
  UserAddOutlined,
  LogoutOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "./index.css";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export default function Auth({ onLogin, onRegister, loggedInUser, onLogout }) {
  const nav = useNavigate();
  const screens = useBreakpoint();
  const isMobile = !screens.lg;
  const [msg, ctxHolder] = message.useMessage();

  const [mode, setMode] = useState("login"); 
  const [loginForm] = Form.useForm();
  const [registerForm] = Form.useForm();


  const buildUser = (username) => ({
    name: username,
    avatar: `https://api.dicebear.com/7.x/identicon/svg?seed=${encodeURIComponent(username)}`,
  });

  const handleLoginFinish = (values) => {
    onLogin(buildUser(values.username));
    msg.success("欢迎回来");
    nav("/", { replace: true });
  };

  const handleRegisterFinish = (values) => {
    if (values.password !== values.confirmPassword) {
      msg.error("两次密码不一致");
      return;
    }
    onRegister(buildUser(values.username));
    msg.success("注册成功");
    nav("/", { replace: true });
  };

  if (loggedInUser) {
    return (
      <div className="dmc-shell">
        {ctxHolder}
        <div className="dmc-wrap">
          <div className="dmc-stage">
            <div className="dmc-left">
              <div className="dmc-brand">
                <span className="dmc-sigil" />
                <span className="dmc-brand-text">MY BLOG</span>
              </div>
              <Title level={2} className="dmc-hero-title">WELCOME BACK</Title>
              <Text className="dmc-hero-sub">进入系统，继续你的记录。</Text>
            </div>

            <div className="dmc-right">
              <Card className="dmc-card" bordered={false}>
                <Space direction="vertical" size={16} style={{ width: "100%" }}>
                  <Space align="center" size={12}>
                    <Avatar size={56} src={loggedInUser.avatar} icon={<UserOutlined />} />
                    <div>
                      <Title level={4} style={{ margin: 0 }} className="dmc-card-title">
                        {loggedInUser.name}
                      </Title>
                      <Text className="dmc-muted">已登录</Text>
                    </div>
                  </Space>

                  <Space wrap>
                    <Button type="primary" className="dmc-primary" onClick={() => nav("/")}>
                      进入首页 <ArrowRightOutlined />
                    </Button>
                    <Button danger className="dmc-danger" icon={<LogoutOutlined />} onClick={onLogout}>
                      退出
                    </Button>
                  </Space>
                </Space>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dmc-shell">
      {ctxHolder}

      <div className="dmc-bg">
        <div className="dmc-vignette" />
        <div className="dmc-grid" />
        <div className="dmc-smoke dmc-smoke-a" />
        <div className="dmc-smoke dmc-smoke-b" />
        <div className="dmc-redslash" />
      </div>

      <div className="dmc-wrap">
        <div className="dmc-stage">
          <div className="dmc-left">
            <div className="dmc-brand">
              <span className="dmc-sigil" />
              <span className="dmc-brand-text">MY BLOG</span>
            </div>

            <div className="dmc-hero">
              <Title level={2} className="dmc-hero-title">
                {mode === "login" ? "WELCOME BACK" : "CREATE ACCOUNT"}
              </Title>
              <Text className="dmc-hero-sub">
                {mode === "login" ? "登录后进入内容中心。" : "注册并开启你的记录。"}
              </Text>
            </div>

            <div className="dmc-bullets">
              <div className="dmc-bullet">
                <span className="dmc-dot" /> 恶魔不会哭泣，眼泪是人类的至宝
              </div>
              <div className="dmc-bullet">
                <span className="dmc-dot" /> 有欲望而无行动者滋生瘟疫
              </div>
              <div className="dmc-bullet">
                <span className="dmc-dot" /> 没有不散的筵席，即使是我们
              </div>
            </div>

            {!isMobile && (
              <div className="dmc-left-footer">
                <Space align="center" size={12}>
                <Avatar size={44} src={Logo} />
                  <div className="dmc-left-footer-text">
                    <div className="dmc-lf-title">Devil May Cry</div>
                    <div className="dmc-lf-sub"></div>
                  </div>
                </Space>
              </div>
            )}
          </div>

          <div className="dmc-right">
            <Card className="dmc-card" bordered={false}>
              <div className="dmc-card-head">
                <Title level={4} style={{ margin: 0 }} className="dmc-card-title">
                  {mode === "login" ? "登录" : "注册"}
                </Title>
                <Text className="dmc-muted">
                  {mode === "login" ? "输入账号信息" : "创建新账号"}
                </Text>
              </div>

              {mode === "login" ? (
                <Form
                  form={loginForm}
                  layout="vertical"
                  onFinish={handleLoginFinish}
                  requiredMark={false}
                >
                  <Form.Item
                    label={<span className="dmc-label">用户名</span>}
                    name="username"
                    rules={[{ required: true, message: "请输入用户名" }]}
                  >
                    <Input
                      size="large"
                      prefix={<UserOutlined />}
                      placeholder="Username"
                      className="dmc-input"
                    />
                  </Form.Item>

                  <Form.Item
                    label={<span className="dmc-label">密码</span>}
                    name="password"
                    rules={[{ required: true, message: "请输入密码" }]}
                  >
                    <Input.Password
                      size="large"
                      prefix={<LockOutlined />}
                      placeholder="Password"
                      className="dmc-input"
                    />
                  </Form.Item>

                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    icon={<LoginOutlined />}
                    block
                    className="dmc-primary"
                  >
                    登录
                  </Button>

                  <div className="dmc-switch">
                    <Text className="dmc-muted">还没有账号？</Text>
                    <Button type="link" className="dmc-link" onClick={() => setMode("register")} icon={<UserAddOutlined />}>
                      注册
                    </Button>
                  </div>
                </Form>
              ) : (
                <Form
                  form={registerForm}
                  layout="vertical"
                  onFinish={handleRegisterFinish}
                  requiredMark={false}
                >
                  <Form.Item
                    label={<span className="dmc-label">用户名</span>}
                    name="username"
                    rules={[
                      { required: true, message: "请输入用户名" },
                      { min: 2, message: "用户名至少 2 位" },
                    ]}
                  >
                    <Input
                      size="large"
                      prefix={<UserOutlined />}
                      placeholder="Username"
                      className="dmc-input"
                    />
                  </Form.Item>

                  <Form.Item
                    label={<span className="dmc-label">密码</span>}
                    name="password"
                    rules={[
                      { required: true, message: "请输入密码" },
                      { min: 6, message: "密码至少 6 位" },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      prefix={<LockOutlined />}
                      placeholder="Password"
                      className="dmc-input"
                    />
                  </Form.Item>

                  <Form.Item
                    label={<span className="dmc-label">确认密码</span>}
                    name="confirmPassword"
                    dependencies={["password"]}
                    rules={[
                      { required: true, message: "请再次输入密码" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) return Promise.resolve();
                          return Promise.reject(new Error("两次密码不一致"));
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      size="large"
                      prefix={<LockOutlined />}
                      placeholder="Confirm Password"
                      className="dmc-input"
                    />
                  </Form.Item>

                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    icon={<UserAddOutlined />}
                    block
                    className="dmc-primary"
                  >
                    注册并进入
                  </Button>

                  <div className="dmc-switch">
                    <Button type="link" className="dmc-link" onClick={() => setMode("login")} icon={<ArrowLeftOutlined />}>
                      返回登录
                    </Button>
                  </div>
                </Form>
              )}

              <div className="dmc-links">
                <Button type="link" className="dmc-link" onClick={() => nav("/")}>返回首页</Button>
                <Button type="link" className="dmc-link" onClick={() => nav("/archive")}>文章归档</Button>
                <Button type="link" className="dmc-link" onClick={() => nav("/about")}>关于</Button>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
